export const SideMenuStatus = {
    HIDE: 0,
    ENABLE: 1,
    DISABLE: 2
}